import { getPostFeedMetadataPage } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page-http/http';
import { createAction } from '@wix/communities-blog-client-common';
import type { CommonThunkAction } from '@app/types/common-thunk-action.type';

export const FETCH_FEED_METADATA_SUCCESS = 'feedMetadata/FETCH_SUCCESS';
const FETCH_FEED_METADATA_REQUEST = 'feedMetadata/FETCH_REQUEST';
export const FETCH_FEED_METADATA_FAILURE = 'feedMetadata/FETCH_FAILURE';
export const SET_FEED_METADATA_PARAMS = 'feedMetadata/SET_PARAMS';

const fetchFeedMetadataRequest = createAction(FETCH_FEED_METADATA_REQUEST);
const fetchFeedMetadataSuccess = createAction(FETCH_FEED_METADATA_SUCCESS);
export const setFeedMetadataParams = createAction(SET_FEED_METADATA_PARAMS);

const fetchFeedMetadataFailure = createAction(FETCH_FEED_METADATA_FAILURE);

export const fetchFeedMetadata =
  (): CommonThunkAction<unknown> =>
  async (dispatch, getState, { httpClient, errorHandler }) => {
    dispatch(fetchFeedMetadataRequest());
    const { withErrorHandler, getResolvedError } = errorHandler;
    const params = getState().listMetadataParams;

    try {
      const result = await withErrorHandler(
        () => httpClient.request(getPostFeedMetadataPage(params!)),
        {
          errorCodesMap: { applicationError: { PERMISSION_DENIED: false, UNAUTHENTICATED: false } },
        },
      );
      dispatch(fetchFeedMetadataSuccess(result.data));
    } catch (error) {
      getResolvedError(error);
      dispatch(fetchFeedMetadataFailure(error));
    }
  };
